"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConfigValue = void 0;
/**
 * resolves a config value into a string, to be used inside of things that are provided configurations
 */
const resolveConfigValue = async (provider) => {
    return typeof provider === 'function'
        ? await provider()
        : provider;
};
exports.resolveConfigValue = resolveConfigValue;
